export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/flat_minimalist.d9d3dc3.svg";